(function(){
  function q(sel,root){return (root||document).querySelector(sel)}
  function qa(sel,root){return Array.from((root||document).querySelectorAll(sel))}
  function lock(on){
    var html=document.documentElement;
    var body=document.body;
    if(html)html.classList.toggle('mg2-lock',!!on);
    if(body)body.classList.toggle('mg2-lock',!!on);
  }
  function visibleOpen(el){
    if(!el||!el.classList.contains('is-open'))return false;
    return el.getAttribute('aria-hidden')!=='true';
  }
  function clearStaleLock(){
    var drawer=q('[data-mg2-mobile-drawer]');
    var search=q('[data-mg2-search-overlay]');
    lock(visibleOpen(drawer)||visibleOpen(search));
  }
  function resetOverlayState(){
    qa('[data-mg2-mobile-drawer],[data-mg2-search-overlay]').forEach(function(el){
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden','true');
    });
    qa('[data-mg2-mobile-open],[data-mg2-search-open]').forEach(function(el){el.setAttribute('aria-expanded','false')});
    lock(false);
  }
  // A navigation, bfcache restore or Theme Editor refresh must always start scrollable.
  // Drawers are transient UI and should never survive across page lifecycle events.
  lock(false);
  window.addEventListener('pageshow',function(){setTimeout(resetOverlayState,0)});
  document.addEventListener('shopify:section:load',function(){setTimeout(resetOverlayState,0)});
  document.addEventListener('shopify:section:unload',function(){setTimeout(clearStaleLock,0)});
  document.addEventListener('DOMContentLoaded',function(){
    resetOverlayState();
    var drawer=q('[data-mg2-mobile-drawer]');
    var open=q('[data-mg2-mobile-open]');
    var close=q('[data-mg2-mobile-close]');
    var search=q('[data-mg2-search-overlay]');
    var lastDrawerTrigger=null;
    var lastSearchTrigger=null;

    function isOpen(el){return visibleOpen(el)}
    function updateLock(){lock(isOpen(drawer)||isOpen(search))}
    function focusables(root){
      if(!root)return [];
      return qa('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])',root).filter(function(el){return el.offsetParent!==null});
    }
    function trapFocus(e,root){
      if(e.key!=='Tab'||!root)return;
      var items=focusables(root);
      if(!items.length){e.preventDefault();return}
      var first=items[0],last=items[items.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
    }
    function setDrawer(v,restoreFocus){
      if(!drawer)return;
      if(v){lastDrawerTrigger=document.activeElement;drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');if(open)open.setAttribute('aria-expanded','true');updateLock();if(close)setTimeout(function(){close.focus()},30)}
      else{drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');if(open)open.setAttribute('aria-expanded','false');updateLock();if(restoreFocus!==false&&lastDrawerTrigger&&lastDrawerTrigger.focus&&!isOpen(search))lastDrawerTrigger.focus()}
    }
    if(open)open.addEventListener('click',function(){setDrawer(true)});
    if(close)close.addEventListener('click',function(){setDrawer(false)});

    function setSearch(v,trigger){
      if(!search)return;
      if(v){
        lastSearchTrigger=trigger||document.activeElement;
        if(isOpen(drawer))setDrawer(false,false);
        search.classList.add('is-open');search.setAttribute('aria-hidden','false');
        qa('[data-mg2-search-open]').forEach(function(el){el.setAttribute('aria-expanded','true')});
        updateLock();
        var i=q('input[type="search"]',search);if(i)setTimeout(function(){i.focus()},30);
      }else{
        search.classList.remove('is-open');search.setAttribute('aria-hidden','true');
        qa('[data-mg2-search-open]').forEach(function(el){el.setAttribute('aria-expanded','false')});
        updateLock();
        var target=lastSearchTrigger;
        if(target&&drawer&&drawer.contains(target))target=open;
        if(target&&target.focus)setTimeout(function(){target.focus()},0);
      }
    }
    qa('[data-mg2-search-open]').forEach(function(el){el.addEventListener('click',function(){setSearch(true,el)})});
    qa('[data-mg2-search-close]').forEach(function(el){el.addEventListener('click',function(){setSearch(false)})});
    if(search)search.addEventListener('click',function(e){if(e.target===search)setSearch(false)});
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'){if(isOpen(search)){e.preventDefault();setSearch(false);return}if(isOpen(drawer)){e.preventDefault();setDrawer(false);return}}
      if(isOpen(search))trapFocus(e,search);else if(isOpen(drawer))trapFocus(e,drawer);
    });
    // Synchronize once after the real header markup exists. Closed overlays must never lock page scroll.
    updateLock();
    // Header mega menus: close when a pointer leaves the header; CSS handles hover/focus.
    // Simple reveal helper, deliberately restrained like Megamo.
    if('IntersectionObserver' in window){
      var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mg2-in');obs.unobserve(e.target)}})},{threshold:.08,rootMargin:'0px 0px -5% 0px'});
      qa('[data-mg2-reveal]').forEach(function(el){obs.observe(el)});
    }
  });
})();

/* V2.1 product-story anchors */
document.addEventListener('click',function(e){
  var specs=e.target.closest&&e.target.closest('[data-mg2-scroll-specs]');
  if(specs){
    e.preventDefault();
    var target=document.querySelector('[data-mg2-pdp-tech]')||document.querySelector('[id^="lbx-product-tabs-"]')||document.querySelector('.lbx-product-tabs')||document.querySelector('.product-tabs');
    if(target)target.scrollIntoView({behavior:'smooth',block:'start'});
  }
  var top=e.target.closest&&e.target.closest('[data-mg2-scroll-top]');
  if(top){e.preventDefault();window.scrollTo({top:0,behavior:'smooth'});}
});

/* V2.2 technical tabs and bridge to the existing size-advisor logic. */
document.addEventListener('click',function(e){
  var tab=e.target.closest&&e.target.closest('[data-mg2-tech-tab]');
  if(tab){
    var root=tab.closest('[data-mg2-pdp-tech]');
    if(!root)return;
    var key=tab.getAttribute('data-mg2-tech-tab');
    root.querySelectorAll('[data-mg2-tech-tab]').forEach(function(b){var on=b===tab;b.classList.toggle('is-active',on);b.setAttribute('aria-selected',on?'true':'false');b.setAttribute('tabindex',on?'0':'-1')});
    root.querySelectorAll('[data-mg2-tech-panel]').forEach(function(p){var on=p.getAttribute('data-mg2-tech-panel')===key;p.classList.toggle('is-active',on);p.hidden=!on});
    return;
  }
  var size=e.target.closest&&e.target.closest('[data-mg2-size-guide]');
  if(size){
    e.preventDefault();
    var original=document.querySelector('.lbx-product-pro [data-lbx-size-guide-open]');
    if(original)original.click(); else window.scrollTo({top:0,behavior:'smooth'});
  }
});

document.addEventListener('keydown',function(e){
  var tab=e.target.closest&&e.target.closest('[data-mg2-tech-tab]');
  if(!tab)return;
  if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
  var root=tab.closest('[data-mg2-pdp-tech]');
  if(!root)return;
  var tabs=Array.prototype.slice.call(root.querySelectorAll('[data-mg2-tech-tab]'));
  var index=tabs.indexOf(tab);
  if(index<0||!tabs.length)return;
  e.preventDefault();
  if(e.key==='Home')index=0;
  else if(e.key==='End')index=tabs.length-1;
  else if(e.key==='ArrowRight')index=(index+1)%tabs.length;
  else index=(index-1+tabs.length)%tabs.length;
  tabs[index].focus();
  tabs[index].click();
});

/* V2.4 · dealer locator */
(function () {
  function bootDealers(root) {
    if (!root || root.dataset.mg2Ready === '1') return;
    root.dataset.mg2Ready = '1';
    var search = root.querySelector('[data-mg2-dealer-search]');
    var kind = root.querySelector('[data-mg2-dealer-kind]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mg2-dealer-card]'));
    var count = root.querySelector('[data-mg2-dealer-count]');
    var empty = root.querySelector('[data-mg2-dealer-empty]');
    var map = root.querySelector('[data-mg2-dealer-map]');

    function normalize(value) {
      return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    function applyFilters() {
      var q = normalize(search && search.value);
      var k = kind ? kind.value : 'all';
      var visible = 0;
      cards.forEach(function (card) {
        var matchesText = !q || normalize(card.dataset.search).indexOf(q) !== -1;
        var matchesKind = k === 'all' || card.dataset.kind === k || (k === 'store' && card.dataset.kind !== 'online');
        var show = matchesText && matchesKind;
        card.hidden = !show;
        if (show) visible++;
      });
      if (count) count.textContent = visible;
      if (empty) empty.hidden = visible !== 0;
    }
    function selectCard(card) {
      cards.forEach(function (item) { item.classList.toggle('is-active', item === card); });
      if (map && card.dataset.mapSrc && map.getAttribute('src') !== card.dataset.mapSrc) {
        map.setAttribute('src', card.dataset.mapSrc);
      }
    }
    if (search) search.addEventListener('input', applyFilters);
    if (kind) kind.addEventListener('change', applyFilters);
    cards.forEach(function (card) {
      var trigger = card.querySelector('[data-mg2-dealer-select]');
      if (trigger) trigger.addEventListener('click', function () { selectCard(card); });
    });
    applyFilters();
  }
  function init() {
    document.querySelectorAll('[data-mg2-dealers]').forEach(bootDealers);
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();

/* V2.8 · identify editorial family collection pages */
(function(){
  function mark(){ if(document.querySelector('[data-mg2-family-story]')) document.body.classList.add('mg2-has-family-story'); }
  document.addEventListener('DOMContentLoaded',mark); document.addEventListener('shopify:section:load',mark); mark();
})();

/* V2.9 · Megamo-like mega-menu visual preview driven by Shopify menu objects. */
(function(){
  function bootMega(mega){
    if(!mega || mega.dataset.mg2PreviewReady==='1') return;
    mega.dataset.mg2PreviewReady='1';
    var visual=mega.querySelector('[data-mg2-mega-visual]');
    var img=mega.querySelector('[data-mg2-mega-preview]');
    var links=Array.prototype.slice.call(mega.querySelectorAll('[data-mg2-mega-image]'));
    if(!visual || !img || !links.length) return;
    function show(link){
      var src=link && link.getAttribute('data-mg2-mega-image');
      if(!src) return;
      if(img.getAttribute('src')!==src) img.setAttribute('src',src);
      img.hidden=false;
      visual.classList.add('has-image');
    }
    function reset(){
      visual.classList.remove('has-image');
      img.hidden=true;
    }
    links.forEach(function(link){
      link.addEventListener('mouseenter',function(){show(link)});
      link.addEventListener('focus',function(){show(link)});
    });
    mega.addEventListener('mouseleave',reset);
    mega.addEventListener('focusout',function(e){if(!mega.contains(e.relatedTarget)) reset()});
  }
  function init(){document.querySelectorAll('[data-mg2-mega]').forEach(bootMega)}
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
  init();
})();

/* V2.10 · one visual theme only. Legacy theme toggles are kept in the codebase for
   compatibility, but the new Megamo-derived UI is deliberately light and fixed. */
(function(){
  function applyUnifiedLight(){
    var html=document.documentElement, body=document.body;
    [html,body].forEach(function(node){
      if(!node)return;
      node.setAttribute('data-lbx-color-scheme','light');
      node.setAttribute('data-labosch-theme','light');
      node.setAttribute('data-theme','light');
      node.classList.add('labosch-light','light');
      node.classList.remove('labosch-dark','dark','theme-dark');
      try{node.style.colorScheme='light';}catch(e){}
    });
    document.querySelectorAll('[data-labosch-theme-switch],.labosch-theme-switch,[data-labosch-global-theme-switch],.lbx-theme-switch,.lbxw-global-theme-switch').forEach(function(el){
      el.hidden=true; el.setAttribute('aria-hidden','true'); el.style.display='none';
    });
    document.querySelectorAll('.lbx-comparator').forEach(function(root){
      root.setAttribute('data-lbx-resolved-theme','light');
    });
    document.querySelectorAll('.lb-renove').forEach(function(root){
      root.setAttribute('data-labosch-theme','light');
    });
  }
  function boot(){applyUnifiedLight();setTimeout(applyUnifiedLight,80);setTimeout(applyUnifiedLight,500);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  window.addEventListener('load',function(){setTimeout(applyUnifiedLight,0);},{once:true});
  document.addEventListener('shopify:section:load',function(){setTimeout(applyUnifiedLight,0);});
})();

/* V2.17 · catalogue compare controls bridge to the existing comparator storage. */
(function(){
  var KEY='lbxComparatorSelection';
  function tray(){ return document.querySelector('[data-mg2-compare-tray]'); }
  function isMobile(){
    try{return window.matchMedia('(max-width: 900px)').matches}catch(e){return window.innerWidth<=900}
  }
  function maxItems(){ return 2; }
  function labels(){
    var node=tray();
    var desktopMax=node&&node.getAttribute('data-mg2-label-max')||'Máx. 2';
    var mobileMax=node&&node.getAttribute('data-mg2-label-max-mobile')||desktopMax;
    return {
      compare:node&&node.getAttribute('data-mg2-label-compare')||'Compare',
      remove:node&&node.getAttribute('data-mg2-label-remove')||'Quitar del comparador',
      add:node&&node.getAttribute('data-mg2-label-add')||'Add to comparison',
      max:isMobile()?mobileMax:desktopMax
    };
  }
  function read(){
    try{
      var value=JSON.parse(localStorage.getItem(KEY)||'[]');
      return Array.isArray(value)?value.filter(Boolean).slice(0,2):[];
    }catch(e){return []}
  }
  function normalize(items){
    var unique=[];
    (items||[]).forEach(function(item){ if(item && unique.indexOf(item)===-1) unique.push(item); });
    return unique.slice(0,maxItems());
  }
  function write(items){try{localStorage.setItem(KEY,JSON.stringify(normalize(items)))}catch(e){}}
  function sync(root){
    var selected=read();
    (root||document).querySelectorAll('[data-mg2-compare-handle]').forEach(function(button){
      var handle=button.getAttribute('data-mg2-compare-handle');
      var active=selected.indexOf(handle)!==-1;
      button.setAttribute('aria-pressed',active?'true':'false');
      button.classList.toggle('is-selected',active);
      var text=labels();
      var idle=button.getAttribute('data-mg2-compare-label-idle') || (button.dataset.mg2BaseLabel!==undefined ? button.dataset.mg2BaseLabel : text.compare);
      var activeLabel=button.getAttribute('data-mg2-compare-label-active') || text.remove;
      var labelNode=button.querySelector('[data-mg2-compare-label]');
      if(button.dataset.mg2BaseLabel===undefined)button.dataset.mg2BaseLabel=idle;
      if(labelNode)labelNode.textContent=active?activeLabel:idle;
      button.setAttribute('title',active?text.remove:text.add);
      button.setAttribute('aria-label',(active?text.remove:text.add)+' '+(button.closest('[data-lbx-product-card]')?.getAttribute('data-lbx-title')||''));
    });
    var maxNode=document.querySelector('[data-mg2-compare-max]');
    if(maxNode)maxNode.textContent=String(maxItems());
  }
  function enforceCap(){
    var selected=read();
    var limited=normalize(selected);
    if(limited.length!==selected.length){
      try{localStorage.setItem(KEY,JSON.stringify(limited))}catch(e){}
      try{document.dispatchEvent(new CustomEvent('mg2:compare-change',{detail:{items:limited.slice()}}))}catch(e){}
    }
    sync(document);
  }
  function flashLimit(button){
    button.classList.add('is-limit');
    var labelNode=button.querySelector('[data-mg2-compare-label]');
    var original=labelNode?labelNode.textContent:'';
    if(labelNode)labelNode.textContent=labels().max;
    window.setTimeout(function(){
      button.classList.remove('is-limit');
      sync(button.closest('[data-lbx-product-card]')||document);
      if(labelNode && !button.classList.contains('is-selected')) labelNode.textContent=button.getAttribute('data-mg2-compare-label-idle') || button.dataset.mg2BaseLabel || labels().compare;
      if(labelNode && button.classList.contains('is-selected')) labelNode.textContent=button.getAttribute('data-mg2-compare-label-active') || labels().remove;
      if(labelNode && !labelNode.textContent && original)labelNode.textContent=original;
    },1100);
  }
  document.addEventListener('click',function(event){
    var button=event.target.closest&&event.target.closest('[data-mg2-compare-handle]');
    if(!button)return;
    event.preventDefault();event.stopPropagation();
    var handle=button.getAttribute('data-mg2-compare-handle');
    if(!handle)return;
    var selected=read();
    var index=selected.indexOf(handle);
    if(index!==-1){selected.splice(index,1)}
    else if(selected.length<maxItems()){selected.push(handle)}
    else{ flashLimit(button); return; }
    write(selected);sync(document);
    try{document.dispatchEvent(new CustomEvent('mg2:compare-change',{detail:{items:normalize(selected).slice()}}))}catch(e){}
  });
  function init(){enforceCap()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  window.addEventListener('storage',function(e){if(e.key===KEY)enforceCap()});
  window.addEventListener('resize',function(){ window.clearTimeout(window.__lbxCompareResizeTimer); window.__lbxCompareResizeTimer=window.setTimeout(enforceCap,120); });
})();

/* MG2 V2.17 · generic product-card colour previews outside the catalogue */
(() => {
  const norm = (value = '') => String(value).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const sameColor = (key, candidateKey, candidateLabel) => {
    const a = norm(key);
    const b = norm(`${candidateKey || ''} ${candidateLabel || ''}`);
    if (!a || !b) return false;
    return a === b || a.includes(b) || b.includes(a);
  };
  const findSources = (card, swatch) => {
    const key = swatch.getAttribute('data-lbx-swatch-key') || swatch.getAttribute('data-lbx-swatch-label') || '';
    const out = [];
    card.querySelectorAll('[data-lbx-color-media-src]').forEach((node) => {
      if (!sameColor(key, node.getAttribute('data-lbx-color-media-key'), node.getAttribute('data-lbx-color-media-label'))) return;
      const src = node.getAttribute('data-lbx-color-media-src');
      if (src && !out.includes(src)) out.push(src);
    });
    if (!out.length) {
      card.querySelectorAll('[data-lbx-color-src]').forEach((node) => {
        if (!sameColor(key, node.getAttribute('data-lbx-color-key'), node.getAttribute('data-lbx-color-label'))) return;
        const src = node.getAttribute('data-lbx-color-src');
        if (src && !out.includes(src)) out.push(src);
      });
    }
    return out;
  };
  const apply = (swatch, persist = false) => {
    const card = swatch.closest('[data-lbx-product-card]');
    if (!card || card.closest('[data-lbx-catalog]')) return;
    const img = card.querySelector('[data-lbx-primary-src]');
    if (!img) return;
    const sources = findSources(card, swatch);
    if (!sources.length) return;
    if (!img.dataset.mg2OriginalSrc) img.dataset.mg2OriginalSrc = img.getAttribute('data-lbx-primary-src') || img.currentSrc || img.src || '';
    img.src = sources[0];
    if (persist) {
      img.setAttribute('data-lbx-primary-src', sources[0]);
      if (sources[1]) img.setAttribute('data-lbx-hover-src', sources[1]);
      card.querySelectorAll('[data-lbx-card-color-swatch]').forEach((item) => item.classList.toggle('is-active', item === swatch));
    }
  };
  const restore = (swatch) => {
    const card = swatch.closest('[data-lbx-product-card]');
    if (!card || card.closest('[data-lbx-catalog]')) return;
    const img = card.querySelector('[data-lbx-primary-src]');
    if (!img) return;
    const current = img.getAttribute('data-lbx-primary-src') || img.dataset.mg2OriginalSrc;
    if (current) img.src = current;
  };
  const init = (scope = document) => {
    scope.querySelectorAll?.('[data-lbx-product-card]:not([data-mg2-generic-swatch-ready])').forEach((card) => {
      if (card.closest('[data-lbx-catalog]')) return;
      card.dataset.mg2GenericSwatchReady = 'true';
      card.querySelectorAll('[data-lbx-card-color-swatch]').forEach((swatch) => {
        swatch.addEventListener('pointerenter', () => apply(swatch, false));
        swatch.addEventListener('pointerleave', () => restore(swatch));
        swatch.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); apply(swatch, true); });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

/* V2.28 · global Megamo-style 0/3 comparator tray. Reuses the existing
   lbxComparatorSelection contract used by the dedicated comparator page. */
(function(){
  var KEY='lbxComparatorSelection';
  var tray=document.querySelector('[data-mg2-compare-tray]');
  if(!tray)return;
  var isHome=document.body && document.body.getAttribute('data-template')==='index';
  var homeActivated=false;
  var count=tray.querySelector('[data-mg2-compare-count]');
  var countMax=tray.querySelector('[data-mg2-compare-max]');
  var slots=Array.from(tray.querySelectorAll('[data-mg2-compare-slot]'));
  var clear=tray.querySelector('[data-mg2-compare-clear]');
  var go=tray.querySelector('[data-mg2-compare-go]');
  var collapse=tray.querySelector('[data-mg2-compare-collapse]');
  var productCache={};
  var trayText={
    placeholder:tray.getAttribute('data-mg2-label-placeholder')||'Add product',
    selected:tray.getAttribute('data-mg2-label-selected')||'Product selected',
    removeProduct:tray.getAttribute('data-mg2-label-remove-product')||'Quitar producto',
    show:tray.getAttribute('data-mg2-label-show')||'Mostrar comparador',
    hide:tray.getAttribute('data-mg2-label-hide')||'Ocultar comparador'
  };

  function isMobile(){
    try{return window.matchMedia('(max-width: 900px)').matches}catch(e){return window.innerWidth<=900}
  }
  function maxItems(){ return 2; }
  function read(){
    try{
      var v=JSON.parse(localStorage.getItem(KEY)||'[]');
      return Array.isArray(v)?v.filter(Boolean).slice(0,2):[];
    }catch(e){return []}
  }
  function normalize(items){
    var unique=[];
    (items||[]).forEach(function(item){ if(item && unique.indexOf(item)===-1) unique.push(item); });
    return unique.slice(0,maxItems());
  }
  function write(items){
    var normalized=normalize(items);
    try{localStorage.setItem(KEY,JSON.stringify(normalized))}catch(e){}
    try{document.dispatchEvent(new CustomEvent('mg2:compare-change',{detail:{items:normalized.slice()}}))}catch(e){}
  }
  function esc(value){
    return String(value||'').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})
  }
  function money(cents){
    if(typeof cents!=='number'||!Number.isFinite(cents))return '';
    try{return new Intl.NumberFormat(document.documentElement.lang||'es-ES',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR',maximumFractionDigits:2,minimumFractionDigits:cents%100?2:0}).format(cents/100)}catch(e){return ''}
  }
  function paintSlot(slot,handle,index){
    if(!slot)return;
    if(index>=maxItems()){
      slot.innerHTML='';
      slot.hidden=true;
      return;
    }
    slot.hidden=false;
    if(!handle){slot.innerHTML='<span class="mg2-compare-tray__placeholder">'+esc(trayText.placeholder)+'</span>';return}
    var data=productCache[handle];
    if(!data){
      slot.innerHTML='<span class="mg2-compare-tray__placeholder">'+esc(trayText.selected)+'</span><button type="button" class="mg2-compare-tray__remove" data-mg2-compare-remove="'+esc(handle)+'" aria-label="'+esc(trayText.removeProduct)+'">×</button>';
      fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'})
        .then(function(r){if(!r.ok)throw new Error('product');return r.json()})
        .then(function(p){
          productCache[handle]={title:p.title||handle,url:p.url||(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'products/'+handle),image:p.featured_image||((p.images||[])[0])||'',price:p.price};
          if(read()[index]===handle)paintSlot(slot,handle,index);
        }).catch(function(){});
      return;
    }
    var img=data.image?'<img class="mg2-compare-tray__thumb" src="'+esc(data.image)+'" alt="" loading="lazy">':'';
    slot.innerHTML=img+'<a class="mg2-compare-tray__product" href="'+esc(data.url)+'"><strong>'+esc(data.title)+'</strong><span>'+esc(money(data.price))+'</span></a><button type="button" class="mg2-compare-tray__remove" data-mg2-compare-remove="'+esc(handle)+'" aria-label="'+esc(trayText.removeProduct)+' '+esc(data.title)+'">×</button>';
  }
  function enforceCap(){
    var items=read();
    var limited=normalize(items);
    if(limited.length!==items.length){
      try{localStorage.setItem(KEY,JSON.stringify(limited))}catch(e){}
      items=limited;
    }
    return items;
  }
  function render(){
    if(isHome && !homeActivated){tray.hidden=true;return;}
    var items=enforceCap();
    if(count)count.textContent=String(items.length);
    if(countMax)countMax.textContent=String(maxItems());
    slots.forEach(function(slot,i){paintSlot(slot,items[i]||'',i)});
    if(go){
      var enabled=items.length>=2;
      go.classList.toggle('is-disabled',!enabled);
      go.setAttribute('aria-disabled',enabled?'false':'true');
    }
    tray.hidden=items.length===0;
  }
  tray.addEventListener('click',function(e){
    var remove=e.target.closest&&e.target.closest('[data-mg2-compare-remove]');
    if(remove){
      var handle=remove.getAttribute('data-mg2-compare-remove');
      write(read().filter(function(x){return x!==handle}));
      return;
    }
    if(e.target.closest&&e.target.closest('[data-mg2-compare-clear]')){write([]);return}
    if(e.target.closest&&e.target.closest('[data-mg2-compare-collapse]')){
      var collapsed=tray.classList.toggle('is-collapsed');
      collapse.setAttribute('aria-expanded',collapsed?'false':'true');
      collapse.setAttribute('aria-label',collapsed?trayText.show:trayText.hide);
    }
  });
  document.addEventListener('mg2:compare-change',function(){homeActivated=true;render()});
  window.addEventListener('storage',function(e){if(e.key===KEY)render()});
  document.addEventListener('shopify:section:load',render);
  window.addEventListener('resize',function(){ window.clearTimeout(window.__lbxCompareTrayResizeTimer); window.__lbxCompareTrayResizeTimer=window.setTimeout(render,120); });
  render();
})();
